import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chatDate',
  standalone: true,
  pure: true
})
export class ChatDatePipe implements PipeTransform {
  // to show chat messages time in 'shortTime' format for today's messages and in medium format for others

  transform(timestamp: string): string {
    if (!timestamp) return '';

    const date = new Date(timestamp);
    const today = new Date();

    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();

    return isToday
      ? new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' }).format(date)
      : new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }).format(date);

  }
}
